// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22Xp3","badges":"styles_badges__2np-i"};